import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekGrid = styled(Grid)(({ theme }) => ({}));

export { PeekGrid, PeekGrid as default };
